import { PlanogramItemOrientation } from "@CommonTypes/merchflow/pog/item";

export const RoutePutInputsStoreProducts = "/inputs/store-products";

export interface PayloadPutInputsStoreProducts {
  store_products: StoreProduct[];
}

export interface StoreProduct {
  store_product_id: number;
  product_id: number;
  store_id: number;
  store_code: string;
  cdt0: string | null;
  cdt1: string | null;
  cdt2: string | null;
  cdt3: string | null;
  cdt1_priority: number | null;
  cdt2_priority: number | null;
  cdt3_priority: number | null;
  quantity: number;
  profit: number;
  sales_amount: number;
  dispersion: number;
  min_days_of_supply: number;
  max_days_of_supply: number;
  min_on_shelf: number;
  min_facings: number;
  max_facings: number;
  adjustment_x: number | null;
  adjustment_y: number | null;
  adjustment_z: number | null;
  notes: string | null;
  special_zone_ban: string | null;
  scenario1: string | null;
  scenario2: string | null;
  scenario3: string | null;
  created_by: number | null;
  created_at: Date | null;
  price: number;
  order_num: number;
  divider_width: number;
  divider_height: number;
  nesting_height: number | null;
  nesting_width: number | null;
  nesting_depth: number | null;
  peg_code: string | null;
  item_hang_hole_x: number | null;
  item_hang_hole_y: number | null;
  gtin: string | null;
  mpl: number;
  min_stack: number;
  max_stack: number;
  no_of_units_in_case: number | null;
  no_of_units_in_tray: number | null;
  merchandising_style: "CASE" | "TRAY" | "UNIT";
  flavour: string | null;
  valid_orientations: PlanogramItemOrientation[];
  shelf_type: "BASKET" | "HANGCELL" | "PEGBOARD" | "REGULAR" | "RISER";
  ranking: number | null;
  space_mix: number | null;
  is_oos: boolean;
  is_new_item: boolean;
  is_core_range: boolean;
}
